import { NavLink } from "react-router-dom";
import { useAppContext } from "../context/app.context";
import { Images } from "../helper/images";
import { getStorageData } from "../service/storage.service";
import { Constant } from "../helper/constant";
import { useMemo } from "react";

const SideMenu = () => {
  const { showLeftMenu, updateLeftMenu, companyInfoSaved } = useAppContext();

  const activeStyle = ({ isActive }) => ({ color: isActive ? "#217CE8" : "" });

  // 👇 recompute userInfo whenever companyInfoSaved changes
  const userInfo = useMemo(() => {
    return getStorageData(Constant.STORAGE_KEYS.USER_INFO);
  }, [companyInfoSaved]);

  return (
    <section
      className={`leftbar navigatorlftbar text-white px-3 py-3 ${showLeftMenu ? "active" : ""}`}
    >
      <nav className="nav active ">
        <div className="mobilemnuclswrp d-flex flex-column justify-content-between">
          <ul className="navlist navigatorlist">
            <li>
              <div className="navigatorlist-heading">Introduction</div>
              <ul>
                <li><DisabledNavLink style={activeStyle} to="/">Objective</DisabledNavLink></li>
                <li><DisabledNavLink style={activeStyle} to="/company-intro">Company Intro</DisabledNavLink></li>
              </ul>
            </li>
            <li>
              <div className="navigatorlist-heading">Assessment</div>
              <ul>
                <li><DisabledNavLink style={activeStyle} to="/ai-maturity-eval" disabled={!userInfo}>AI Maturity Evaluation</DisabledNavLink></li>
                <li><DisabledNavLink style={activeStyle} to="/gap-analysis" disabled={!userInfo}>Gap Analysis</DisabledNavLink></li>
              </ul>
            </li>
            <li>
              <div className="navigatorlist-heading">Value and Impact</div>
              <ul>
                <li><DisabledNavLink style={activeStyle} to="/ai-value" disabled={!userInfo}>AI Value</DisabledNavLink></li>
                <li><DisabledNavLink style={activeStyle} to="/strategic-impact" disabled={!userInfo}>Strategic Implications</DisabledNavLink></li>
              </ul>
            </li>
            <li>
              <div className="navigatorlist-heading">Execution Plan</div>
              <ul>
                <li><DisabledNavLink style={activeStyle} to="/ai-roadmap" disabled={!userInfo}>AI Roadmap</DisabledNavLink></li>
                <li><DisabledNavLink style={activeStyle} to="/ai-usecase" disabled={!userInfo}>AI Use Case Booklet</DisabledNavLink></li>
                <li><DisabledNavLink style={activeStyle} to="/timeline" disabled={!userInfo}>Implication Timeline and Cost</DisabledNavLink></li>
              </ul>
            </li>
            <li>
              <div className="navigatorlist-heading">Why Incorp AI</div>
              <ul>
                <li><DisabledNavLink style={activeStyle} to="/unique-diffs">Unique Differentiators</DisabledNavLink></li>
                <li><DisabledNavLink style={activeStyle} to="/track-record">Track Record</DisabledNavLink></li>
              </ul>
            </li>
            <li>
              <div className="navigatorlist-heading">Support</div>
              <ul>
                <li><DisabledNavLink style={activeStyle} to="/faq">FAQs</DisabledNavLink></li>
                <li><DisabledNavLink style={activeStyle} to="/client-assistance-channel">Client Assistance Channels</DisabledNavLink></li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      <div
        className={`iconclic2 ${showLeftMenu ? "iconactive" : ""}`}
        onClick={() => updateLeftMenu(!showLeftMenu)}
      >
        <img src={Images.sidepanelArrow} alt="side-menu" />
      </div>
    </section>
  );
};

export default SideMenu;

export const DisabledNavLink = ({ disabled, ...props }) => {
  if (disabled) {
    return <span className="d-flex align-items-center gap-1 nav-disabled">{props.children}</span>;
  }
  return <NavLink {...props} className="d-flex align-items-center gap-1">{props.children}</NavLink>;
};
